<script setup>
import { useThemeSetting } from "@/Composable/ThemeSetting";

defineProps({
    transparentMode: {
        type: Boolean,
        default: false,
    },
});

const { toggleTheme, isDark } = useThemeSetting();
</script>
<template>
    <!-- <v-btn @click="toggleTheme" variant="text"  class="">
        <v-icon :color="isDark ? 'white' : 'black'" :icon="isDark ? 'mdi-weather-night' : 'mdi-lightbulb-on-10'">
        </v-icon>
  </v-btn> -->
    <v-btn variant="text" size="small" @click="toggleTheme" slim>
        <svg width="30" height="30" style="max-width: 30px;" :class="[
            transparentMode ? 'text-white' : (isDark ? 'nav-svg-dark-color-mode' : ''),
            'opacity-90 dark:opacity-100'
        ]" :style="transparentMode ? 'filter: brightness(0) invert(1);' : ''">
            <image xlink:href="/assets/svgicons/moon-star.svg" v-if="isDark" src="/assets/svgicons/moon-star.svg"
                width="30" height="30" />
            <image xlink:href="/assets/svgicons/lightbulb-02.svg" v-else src="/assets/svgicons/lightbulb-02.svg"
                width="30" height="30" />
        </svg>
    </v-btn>
</template>
